var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalRechazarAnuncio",attrs:{"titulo":"","tamano":"modal-lg"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-10"},[_c('img',{staticClass:"w-100",attrs:{"src":"/img/pruebas/anuncio1.png","alt":""}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }